import React from 'react';
import './CreateNewNFTProject.scss';
import { connect } from 'react-redux';
import MercurXBackButton from '../../components/MercurXBackButton/MercurXBackButton';
import MercurXProjectDetailInputs
  from '../../components/MercurXProjectDetailInputs/MercurXProjectDetailInputs';

function CreateNewNFTProject() {
  return (
    <div>
      <MercurXBackButton buttonText="Back to NFT project list" />
      <div className="text-fs-head-sm">Create new NFT project</div>
      <MercurXProjectDetailInputs
        showProject={true}
        showNft={true}
        showToken={false}
        showSocial={true}
        showContract={true}
      />
    </div>
  );
}

export default connect(null, null)(CreateNewNFTProject);
